<template>
  <div>
    <my-table :title="title"
              :searchParams="searchParams"
              :isAdd="isAdd"
              :tableData="tableData"
              :singleSearchArr="singleSearchArr"
              :isSingleSearch="isSingleSearch"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup"
              @singleSearch="singleSearch">
      <div slot="table">
        <order-table :tableData="tableData.list"></order-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import OrderTable from "./OrderTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getOrderBySearch,newVue,getOrderByState} from "../../network/order";

  export default {
    name: "orderList",
    components: {OrderTable, MyTable},
    data(){
      return {
        title: "订单列表",
        //搜索条件
        searchParams:[
          {
            key:"orderId",
            value:"订单编号"
          },
          {
            key:"payNum",
            value:"支付交易号"
          }
        ],
        //单一搜索条件
        singleSearchArr:[
          {
            key: "0",
            value: "未支付订单"
          },
          {
            key: "1",
            value: "已支付订单"
          },
          {
            key: "2",
            value: "已失效订单"
          },
          {
            key: "3",
            value: "已发货订单"
          },
          {
            key: "4",
            value: "已签收订单"
          },
          {
            key: "5",
            value: "退款中订单"
          },
          {
            key: "6",
            value: "已退款订单"
          },
        ],
        isSingleSearch:true,
        isAdd: false,
        tableData:{},
        searchItems:{},
        orderState: ""
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/order/list";
      this.common.HeaderLocationTwo.name =  "订单管理"
      this.common.HeaderLocationThree.name = "订单列表"
      getOrderBySearch().then(res => {
        this.processorData(res.data)
        this.tableData = res.data
      })
    },
    methods:{
      processorData(data){
        let item = data.list
        for (let i = 0;i<item.length;i++){
          let state = item[i].state
          if (state == "0"){
            item[i].state = "未支付"
          }else if (state == "1"){
            item[i].state = "已支付"
          }else if (state == "2"){
            item[i].state = "已失效"
          }else if (state == "3"){
            item[i].state = "已发货"
          }else if (state == "4"){
            item[i].state = "已签收"
          }else if (state == "5"){
            item[i].state = "退款中"
          }else if (state == "6"){
            item[i].state = "已退款"
          }
        }
        return data;
      },
      singleSearch(state){
        this.orderState = state
        getOrderByState(state).then(res => {
          this.tableData = this.processorData(res.data)
        })
      },
      pageNumChange(pageNum){
        if (this.orderState!=""){
          getOrderByState(this.orderState,pageNum).then(res => {
            this.tableData = this.processorData(res.data)
          })
        }else {
          this.searchEasy(this.searchItems,pageNum);
        }
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let orderId = null;
        let payNum = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "orderId"){
            orderId = searchItems[i].input
          }else if (searchItems[i].value === "payNum"){
            payNum = searchItems[i].input
          }
        }
        getOrderBySearch(orderId,payNum,pageNum).then(res => {
          this.tableData = this.processorData(res.data)
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
    }
  }
</script>

<style scoped>

</style>
